import i18next from 'i18next';
// Only one feature at a time as its not cheap to branch so many keys and we
// want to keep it sane, so one mass babel migrtion at a time!
const ACTIVE_FLAG = 'adoptables_resale';
const featureBrancher = {
    name: 'featureBrancher',
    type: 'postProcessor',
    process: function process(value, key, options, translator) {
        const firstKey = key[0];
        if (translator.options.i18nFeatureBranch && !firstKey.startsWith(translator.options.i18nFeatureBranch)) {
            const branchedKey = `${translator.options.i18nFeatureBranch}.${firstKey}`;
            if (i18next.exists(branchedKey)) {
                return i18next.t(branchedKey);
            }
        }
        return value;
    },
    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
        return {
            postProcess: 'featureBrancher'
        };
    }
};
const setupI18nextFeatureBranching = (flags, i18n)=>{
    if (ACTIVE_FLAG && flags && flags.includes(ACTIVE_FLAG)) {
        i18n.options.i18nFeatureBranch = ACTIVE_FLAG;
    }
};
export default featureBrancher;
export { setupI18nextFeatureBranching };
